<template>
  <div style="height: 100%">
    <label style="padding: 20px 0px 10px 30px;">温湿度设备</label>
    <div v-if="chartDataList.length > 0" style="height: 85%">
      <!-- 5个及以下设备直接显示 -->
      <template v-if="chartDataList.length === 1">
        <div style="height: 100%">
          <HumitureDeviceBarChart :data="chartDataList[0]" style="height: 100%;"></HumitureDeviceBarChart>
        </div>
      </template>
      <!-- 超过5个设备使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%;z-index: 0">
          <el-carousel-item v-for="(chartData, index) in chartDataList" :key="index">
            <HumitureDeviceBarChart :data="chartData" style="height: 100%;"></HumitureDeviceBarChart>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%;padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import HumitureDeviceBarChart from "@/components/echarts/HumitureDeviceBarChart";
import NoData from "@/components/NoData";
import { getSpecialTypeValues } from "@/network/measuring-point-history";

export default {
  name: "controlRoomHumitureDeviceBar",
  components: { HumitureDeviceBarChart, NoData },
  data() {
    return {
      chartDataList: [],
      pageSize: 5,
      deviceType: 'PM_THC', // 温湿度传感器类型
      pointCodes: 'tm,hu' // 温度值,湿度值
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getHumitureDeviceBarData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getHumitureDeviceBarData')
  },
  methods: {
    getData() {
      getSpecialTypeValues(this.deviceType, this.pointCodes).then(res => {
        if (res.code === 0 && res.data) {
          const { devices, devicePointNames, devicePointValues, thresholdValues } = res.data;
          if (devices && devices.length > 0) {
            const validData = this.processData(devices, devicePointValues);
            const thresholds = this.processThresholds(thresholdValues, devicePointNames);
            
            const firstDevicePoints = (devicePointNames && devicePointNames[0]) || [];
            const tempName = firstDevicePoints[0] || '温度';
            const humiName = firstDevicePoints[1] || '湿度';

            if (validData.length > 0) {
              this.chartDataList = this.chunkData(validData, this.pageSize, thresholds, tempName, humiName);
            } else {
              this.chartDataList = [];
            }
          } else {
            this.chartDataList = [];
          }
        } else {
          this.chartDataList = [];
        }
      }).catch(() => {
        this.chartDataList = [];
      });
    },
    // 处理接口返回的数据
    processData(devices, devicePointValues) {
      const result = [];
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const values = devicePointValues[i];
        if (device && values && values.length > 0) {
          result.push({
            deviceName: device.name || '未知设备',
            status: device.status,
            temperature: values[0] || 0,
            humidity: values[1] || 0
          });
        }
      }
      return result;
    },
    // 处理阈值数据
    processThresholds(thresholdValues, devicePointNames) {
      if (!thresholdValues || thresholdValues.length === 0) return null;
      const result = {};
      
      const firstDevicePoints = (devicePointNames && devicePointNames[0]) || [];
      const tempName = firstDevicePoints[0] || '温度';
      const humiName = firstDevicePoints[1] || '湿度';

      // 构建温度阈值 (第一个测点)
      if (thresholdValues[0] && thresholdValues[0].length > 0) {
        result.temperature = thresholdValues[0].map(item => ({
          alarmHigh: item.alarmHigh,
          alarmLow: item.alarmLow,
          levelColor: item.alarmLevel ? item.alarmLevel.levelColor : '#ff0000',
          levelName: item.alarmLevel ? item.alarmLevel.levelName : '',
          pointName: tempName
        }));
      }
      // 湿度阈值 (第二个测点)
      if (thresholdValues[1] && thresholdValues[1].length > 0) {
        result.humidity = thresholdValues[1].map(item => ({
          alarmHigh: item.alarmHigh,
          alarmLow: item.alarmLow,
          levelColor: item.alarmLevel ? item.alarmLevel.levelColor : '#ff0000',
          levelName: item.alarmLevel ? item.alarmLevel.levelName : '',
          pointName: humiName
        }));
      }
      return result;
    },
    // 将数据分组
    chunkData(data, size, thresholds, tempName, humiName) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        const chunk = data.slice(i, i + size);
        result.push({
          deviceNames: chunk.map(item => item.deviceName),
          statuses: chunk.map(item => item.status),
          temperatures: chunk.map(item => item.temperature),
          humidities: chunk.map(item => item.humidity),
          thresholds: thresholds,
          tempName: tempName,
          humiName: humiName
        });
      }
      return result;
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>
